import {Card, CardContent, CardHeader} from "@mui/material";

export const Dashboard = () => (
  <Card>
    <CardHeader title="个人账单管理系统" />
    <CardContent>Powered by Zhang Xt. </CardContent>
  </Card>
);
